/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import useT, {
    UseTranslationOptions,
} from "../../../Basis/Internationalisierung/Hooks/useTranslation";
import i18n from "../../../Basis/Internationalisierung/i18n";
import { KontostatusSammlung } from "../Api/StripeKontoClient";
import AbrechnungAb from "../Queries/AbrechnungAb";
import { Belegarten } from "../Queries/Belegart";
import { BelegstatusWerte } from "../Queries/Belegstatus";
import { KontoMandantStatusSammlung } from "../Queries/KontoMandantStatus";
import { MarkeSammlung, ZahlungsmethodenstatusSammlung, ZahlungsmethodentypSammlung } from "../Queries/Zahlungsmethode";

export const useTranslation = (options?: UseTranslationOptions) => useT("i18nMandanten", options);
export const fixedT = i18n.getFixedT(null, "i18nMandanten");

export const translationKeys = {
    appAccount: {
        abmelden: "appAccount.abmelden",
        mandanten: "appAccount.mandanten",
        mandantAnlegen: "appAccount.mandantAnlegen",
        mandantAnlegenMeldung: "appAccount.mandantAnlegenMeldung",
        passwortAendern: "appAccount.passwortAendern",
        konto: "appAccount.konto",
        kontoAdresse: "appAccount.kontoAdresse",
        eMailAendern: "appAccount.eMailAendern",
        kontoLabel: "appAccount.kontoLabel",
        kontoTitel: "appAccount.kontoTitel"
    },
    mandantView: {
        mandant: "mandantView.mandant",
        details: "mandantView.details",
        firmendaten: "mandantView.firmendaten",
        abgleichseinstellungen: "mandantView.abgleichseinstellungen",
        finanzeinstellungen: "mandantView.finanzeinstellungen",
        kontoAdresse: "mandantView.kontoAdresse",
        nutzende: "mandantView.nutzende",
    },
    mandantDetailsView: {
        bezeichnung: "mandantDetailsView.bezeichnung",
        kennung: "mandantDetailsView.kennung",
        speichern: "mandantDetailsView.speichern",
        loeschen: "mandantDetailsView.loeschen",
        zahlungsmethodeAendern: "mandantDetailsView.zahlungsmethodeAendern",
        zahlungsmethode: "mandantDetailsView.zahlungsmethode",
        zahlungsmethodeStatus: "mandantDetailsView.zahlungsmethodeStatus",
        karteMarke: "mandantDetailsView.karteMarke",
        karteNummer: "mandantDetailsView.karteNummer",
        karteGueltigBis: "mandantDetailsView.karteGueltigBis",
        ibanNummer: "mandantDetailsView.ibanNummer",
        name: "mandantDetailsView.name",
        eMail: "mandantDetailsView.eMail",
        basisUrlAendern: "mandantDetailsView.basisUrlAendern",
        verknuepfteDatensaetzeSperren: "mandantDetailsView.verknuepfteDatensaetzeSperren",
        verknuepfteDatensaetzeSperrenTooltip: "mandantDetailsView.verknuepfteDatensaetzeSperrenTooltip",
        details: "mandantDetailsView.details",
        vertraege: "mandantDetailsView.vertraege",
        provisionsregelung: "mandantDetailsView.provisionsregelung",
        netto: "mandantDetailsView.netto",
        brutto: "mandantDetailsView.brutto",
        staffelProvisionText: "mandantDetailsView.staffelProvisionText",
        normaleProvision: "mandantDetailsView.normaleProvision",
        minimalerAbrechnungsbetrag: "mandantDetailsView.minimalerAbrechnungsbetrag",
        maximalerAbrechnungsbetragProJahr: "mandantDetailsView.maximalerAbrechnungsbetragProJahr",
        keineProvisionBis: "mandantDetailsView.keineProvisionBis",
        maximalerAbrechnungsbetragProMonat: "mandantDetailsView.maximalerAbrechnungsbetragProMonat",
        keineIndexierungDurchSuchmaschinen: "mandantDetailsView.keineIndexierungDurchSuchmaschinen",
    },
    mandantAbgleichDetailsView: {
        speichern: "mandantAbgleichDetailsView.speichern",
        abgleichseinstellungen: "mandantAbgleichDetailsView.abgleichseinstellungen",
        istAbgleichAktiv: "mandantAbgleichDetailsView.istAbgleichAktiv",
        istAbgleichAktivTooltip: "mandantAbgleichDetailsView.istAbgleichAktivTooltip",
        verknuepfteDatensaetzeSperren: "mandantAbgleichDetailsView.verknuepfteDatensaetzeSperren",
        verknuepfteDatensaetzeSperrenTooltip: "mandantAbgleichDetailsView.verknuepfteDatensaetzeSperrenTooltip",
    },
    firmendatenDetailsView: {
        speichern: "firmendatenDetailsView.speichern",
        name1: "firmendatenDetailsView.name1",
        name2: "firmendatenDetailsView.name2",
        name3: "firmendatenDetailsView.name3",
        zusatzangabe1: "firmendatenDetailsView.zusatzangabe1",
        zusatzangabe2: "firmendatenDetailsView.zusatzangabe2",
        zusatzangabe3: "firmendatenDetailsView.zusatzangabe3",
        zusatzangabe1Placeholder: "firmendatenDetailsView.zusatzangabe1Placeholder",
        zusatzangabe2Placeholder: "firmendatenDetailsView.zusatzangabe2Placeholder",
        zusatzangabe3Placeholder: "firmendatenDetailsView.zusatzangabe3Placeholder",
        strasse: "firmendatenDetailsView.strasse",
        postleitzahl: "firmendatenDetailsView.postleitzahl",
        ort: "firmendatenDetailsView.ort",
        region: "firmendatenDetailsView.region",
        land: "firmendatenDetailsView.land",
        iban: "firmendatenDetailsView.iban",
        bank: "firmendatenDetailsView.bank",
        bic: "firmendatenDetailsView.bic",
        anzahlMitarbeitende: "firmendatenDetailsView.anzahlMitarbeitende",
        schwerpunkt: "firmendatenDetailsView.schwerpunkt",
        schwerpunktSonstiges: "firmendatenDetailsView.schwerpunktSonstiges",
        eMail: "firmendatenDetailsView.eMail",
        telefon: "firmendatenDetailsView.telefon",
        mobil: "firmendatenDetailsView.mobil",
        fax: "firmendatenDetailsView.fax",
        umsatzsteuerIdNr: "firmendatenDetailsView.umsatzsteuerIdNr",
        steuernummer: "firmendatenDetailsView.steuernummer",
        homepage: "firmendatenDetailsView.homepage",
        firmaFieldsetCaption: "firmendatenDetailsView.firmaFieldsetCaption",
        anschriftFieldsetCaption: "firmendatenDetailsView.anschriftFieldsetCaption",
        kommunikationFieldsetCaption: "firmendatenDetailsView.kommunikationFieldsetCaption",
        bankverbindungFieldsetCaption: "firmendatenDetailsView.bankverbindungFieldsetCaption",
        steuerangabenFieldsetCaption: "firmendatenDetailsView.steuerangabenFieldsetCaption",
        rechnungsadresseFieldsetCaption: "firmendatenDetailsView.rechnungsadresseFieldsetCaption",
        rechnungsadresse: "firmendatenDetailsView.rechnungsadresse",
        rechnungsadresseName1: "firmendatenDetailsView.rechnungsadresseName1",
        rechnungsadresseName2: "firmendatenDetailsView.rechnungsadresseName2",
        rechnungsadresseName3: "firmendatenDetailsView.rechnungsadresseName3",
        rechnungsadresseStrasse: "firmendatenDetailsView.rechnungsadresseStrasse",
        rechnungsadressePostleitzahl: "firmendatenDetailsView.rechnungsadressePostleitzahl",
        rechnungsadresseOrt: "firmendatenDetailsView.rechnungsadresseOrt",
        rechnungsadresseRegion: "firmendatenDetailsView.rechnungsadresseRegion",
        rechnungsadresseLand: "firmendatenDetailsView.rechnungsadresseLand",
        rechnungsadresseEMail: "firmendatenDetailsView.rechnungsadresseEMail",
        rechnungsadresseTelefon: "firmendatenDetailsView.rechnungsadresseTelefon",
        rechnungsadresseMobil: "firmendatenDetailsView.rechnungsadresseMobil",
        rechnungsadresseFax: "firmendatenDetailsView.rechnungsadresseFax",
        rechnungsadresseUmsatzsteuerIdNr: "firmendatenDetailsView.rechnungsadresseUmsatzsteuerIdNr",
        rechnungsadresseSteuernummer: "firmendatenDetailsView.rechnungsadresseSteuernummer",
    },
    finanzeinstellungenDetailsView: {
        speichern: "finanzeinstellungenDetailsView.speichern",
        nettopreise: "finanzeinstellungenDetailsView.nettopreise",
        nettopreiseTooltip: "finanzeinstellungenDetailsView.nettopreiseTooltip",
        bruttopreise: "finanzeinstellungenDetailsView.bruttopreise",
        bruttopreiseTooltip: "finanzeinstellungenDetailsView.bruttopreiseTooltip",
        umsatzsteuerbefreit: "finanzeinstellungenDetailsView.umsatzsteuerbefreit",
        umsatzsteuerbefreitTooltip: "finanzeinstellungenDetailsView.umsatzsteuerbefreitTooltip",
        waehrung: "finanzeinstellungenDetailsView.waehrung",
        preiseAufBelegen: "finanzeinstellungenDetailsView.preiseAufBelegen",
        standardSteuersatz: "finanzeinstellungenDetailsView.standardSteuersatz",
        rechnungenAnEUAuslandMitUmsatzsteuerIdSindSteuerfrei: "finanzeinstellungenDetailsView.rechnungenAnEUAuslandMitUmsatzsteuerIdSindSteuerfrei",
        rechnungenAnNichtEUAuslandSindSteuerfrei: "finanzeinstellungenDetailsView.rechnungenAnNichtEUAuslandSindSteuerfrei",
        belegAufteilung: "finanzeinstellungenDetailsView.belegAufteilung",
        einenBelegProBestellungErzeugen: "finanzeinstellungenDetailsView.einenBelegProBestellungErzeugen",
        einenBelegProTeilnahmeErzeugen: "finanzeinstellungenDetailsView.einenBelegProTeilnahmeErzeugen",
        belegeNichtAutomatischVersenden: "finanzeinstellungenDetailsView.belegeNichtAutomatischVersenden",
    },
    supportMandantenView: {
        mandanten: "supportMandantenView.mandanten",
        mandant: "supportMandantenView.mandant",
        kennung: "supportMandantenView.kennung",
        datenbankname: "supportMandantenView.datenbankname",
    },
    supportMandantView: {
        mandant: "supportMandantView.mandant",
        firmendaten: "supportMandantView.firmendaten",
        provisionsdaten: "supportMandantView.provisionsdaten",
        konten: "supportMandantView.konten",
        datenschutzeinstellungen: "supportMandantView.datenschutzeinstellungen",
    },
    supportKontoMandantenView: {
        konto: "supportKontoMandantenView.konto",
    },
    supportMandantenNavigationView: {
        mandanten: "supportMandantenNavigationView.mandanten",
    },
    supportMandantDetailsView: {
        kennung: "supportMandantDetailsView.kennung",
        bezeichnung: "supportMandantDetailsView.bezeichnung",
        login: "supportMandantDetailsView.login"
    },
    supportMandantFirmendatenView: {
        speichern: "supportMandantFirmendatenView.speichern",
        firmaFieldsetCaption: "supportMandantFirmendatenView.firmaFieldsetCaption",
        name1: "supportMandantFirmendatenView.name1",
        name2: "supportMandantFirmendatenView.name2",
        name3: "supportMandantFirmendatenView.name3",
        zusatzangabe1: "supportMandantFirmendatenView.zusatzangabe1",
        zusatzangabe2: "supportMandantFirmendatenView.zusatzangabe2",
        zusatzangabe3: "supportMandantFirmendatenView.zusatzangabe3",
        anzahlMitarbeitende: "supportMandantFirmendatenView.anzahlMitarbeitende",
        schwerpunkt: "supportMandantFirmendatenView.schwerpunkt",
        schwerpunktSonstiges: "supportMandantFirmendatenView.schwerpunktSonstiges",
        anschriftFieldsetCaption: "supportMandantFirmendatenView.anschriftFieldsetCaption",
        strasse: "supportMandantFirmendatenView.strasse",
        postleitzahl: "supportMandantFirmendatenView.postleitzahl",
        ort: "supportMandantFirmendatenView.ort",
        region: "supportMandantFirmendatenView.region",
        land: "supportMandantFirmendatenView.land",
        kommunikationFieldsetCaption: "supportMandantFirmendatenView.kommunikationFieldsetCaption",
        eMail: "supportMandantFirmendatenView.eMail",
        mobil: "supportMandantFirmendatenView.mobil",
        telefon: "supportMandantFirmendatenView.telefon",
        fax: "supportMandantFirmendatenView.fax",
        bankverbindungFieldsetCaption:
            "supportMandantFirmendatenView.bankverbindungFieldsetCaption",
        iban: "supportMandantFirmendatenView.iban",
        bic: "supportMandantFirmendatenView.bic",
        bank: "supportMandantFirmendatenView.bank",
        steuerangabenFieldsetCaption: "supportMandantFirmendatenView.steuerangabenFieldsetCaption",
        umsatzsteuerIdNr: "supportMandantFirmendatenView.umsatzsteuerIdNr",
        steuernummer: "supportMandantFirmendatenView.steuernummer",
        finanzeinstellungen: "supportMandantFirmendatenView.finanzeinstellungen",
        preiseaufBelegen: "supportMandantFirmendatenView.preiseaufBelegen",
        nettopreise: "supportMandantFirmendatenView.nettopreise",
        bruttopreise: "supportMandantFirmendatenView.bruttopreise",
        umsatzsteuerbefreit: "supportMandantFirmendatenView.umsatzsteuerbefreit",
        waehrung: "supportMandantFirmendatenView.waehrung",
        homepage: "supportMandantFirmendatenView.homepage",
        euro: "supportMandantFirmendatenView.euro",
        schweizerFranken: "supportMandantFirmendatenView.schweizerFranken",
        kultur: "supportMandantFirmendatenView.kultur",
        deutschDeutschland: "supportMandantFirmendatenView.deutschDeutschland",
        deutschSchweiz: "supportMandantFirmendatenView.deutschSchweiz",
        kultureinstellungen: "supportMandantFirmendatenView.kultureinstellungen",
    },
    supportMandantenBreadcrumb: {
        mandanten: "supportMandantenBreadcrumb.mandanten",
    },
    supportMandantFirmendatenBreadcrumb: {
        firmendaten: "supportMandantFirmendatenBreadcrumb.firmendaten",
    },
    supportMandantProvisionsdatenBreadcrumb: {
        provisionsdaten: "supportMandantProvisionsdatenBreadcrumb.provisionsdaten",
    },
    supportMandantKontenBreadcrumb: {
        konten: "supportMandantKontenBreadcrumb.konten",
    },
    mandantFirmendatenBreadcrumb: {
        firmendaten: "mandantFirmendatenBreadcrumb.firmendaten",
    },
    mandantAbgleichDetailsBreadcrumb: {
        abgleichseinstellungen: "mandantAbgleichDetailsBreadcrumb.abgleichseinstellungen",
    },
    finanzeinstellungenBreadcrumb: {
        finanzeinstellungen: "finanzeinstellungenBreadcrumb.finanzeinstellungen",
    },
    aendereEigenesPasswortDialog: {
        caption: "aendereEigenesPasswortDialog.caption",
        aktuellesPasswort: "aendereEigenesPasswortDialog.aktuellesPasswort",
        neuesPasswort: "aendereEigenesPasswortDialog.neuesPasswort",
        neuesPasswortWiederholung: "aendereEigenesPasswortDialog.neuesPasswortWiederholung",
        abbrechen: "aendereEigenesPasswortDialog.abbrechen",
        aendern: "aendereEigenesPasswortDialog.aendern",
        tooltip: "aendereEigenesPasswortDialog.tooltip",
    },
    startseiteView: {
        teilnahmen: "startseiteView.teilnahmen",
        veranstaltungen: "startseiteView.veranstaltungen",
        belege: "startseiteView.belege",
        auswertungen: "startseiteView.auswertungen",
        ressourcenplan: "startseiteView.ressourcenplan",
        grundeinstellungen: "startseiteView.grundeinstellungen",
        buchungsportal: "startseiteView.buchungsportal",
        ticketscanner: "startseiteView.ticketscanner",
        faq: "startseiteView.faq",
        support: "startseiteView.support",
        verbesserungsvorschlag: "startseiteView.verbesserungsvorschlag",
        neuigkeiten: "startseiteView.neuigkeiten",
        adressen: "startseiteView.adressen",
        dozierende: "startseiteView.dozierende",
        fibuExporte: "startseiteView.fibuExporte",
        bestellungen: "startseiteView.bestellungen",
        veranstaltungsreihen: "startseiteView.veranstaltungsreihen",
        artikel: "startseiteView.artikel",
        bestellteArtikel: "startseiteView.bestellteArtikel",
        belegungen: "startseiteView.belegungen",
        zahlungen: "startseiteView.zahlungen",
        roadmap: "startseiteView.roadmap",
    },
    nutzendeView: {
        konto: "nutzendeView.konto",
        status: "nutzendeView.status",
        einladen: "nutzendeView.einladen",
        du: "nutzendeView.du",
        nutzende: "nutzendeView.nutzende",
        entfernen: "nutzendeView.entfernen",
        dialogCaption: "nutzendeView.dialogCaption",
        dialogText: "nutzendeView.dialogText",
        eigentuemerAendern: "nutzendeView.eigentuemerAendern",
        eigentuemerAendernDialogCaption: "nutzendeView.eigentuemerAendernDialogCaption",
        eigentuemerAendernDialogText: "nutzendeView.eigentuemerAendernDialogText",
        hatGrundeinstellungenRecht: "nutzendeView.hatGrundeinstellungenRecht",
        grundeinstellungenRechtEnziehen: "nutzendeView.grundeinstellungenRechtEnziehen",
        grundeinstellungenRechtErteilen: "nutzendeView.grundeinstellungenRechtErteilen",
    },
    kontoAdresseBreadcrumb: {
        kontoAdresse: "kontoAdresseBreadcrumb.kontoAdresse",
    },
    speichereUmsatzsteuerbefreitDialog: {
        dialogCaption: "speichereUmsatzsteuerbefreitDialog.dialogCaption",
        dialogText: "speichereUmsatzsteuerbefreitDialog.dialogText",
        speichern: "speichereUmsatzsteuerbefreitDialog.speichern",
        abbrechen: "speichereUmsatzsteuerbefreitDialog.abbrechen"
    },
    ladeNutzendenEinDialog: {
        dialogCaption: "ladeNutzendenEinDialog.dialogCaption",
        dialogText: "ladeNutzendenEinDialog.dialogText",
        eMail: "ladeNutzendenEinDialog.eMail",
        einladen: "ladeNutzendenEinDialog.einladen",
        abbrechen: "ladeNutzendenEinDialog.abbrechen"
    },
    bestaetigeEMailAenderungDialog: {
        dialogCaption: "bestaetigeEMailAenderungDialog.dialogCaption",
        dialogText: "bestaetigeEMailAenderungDialog.dialogText",
        passwort: "bestaetigeEMailAenderungDialog.passwort",
        aendern: "bestaetigeEMailAenderungDialog.aendern",
        abbrechen: "bestaetigeEMailAenderungDialog.abbrechen"
    },
    aendereEigeneEMailDialog: {
        dialogCaption: "aendereEigeneEMailDialog.dialogCaption",
        dialogText: "aendereEigeneEMailDialog.dialogText",
        eMail: "aendereEigeneEMailDialog.eMail",
        aendern: "aendereEigeneEMailDialog.aendern",
        abbrechen: "aendereEigeneEMailDialog.abbrechen"
    },
    nutzendeBreadcrumb: {
        nutzende: "nutzendeBreadcrumb.nutzende",
    },
    loescheEigenenMandantDialog: {
        caption: "loescheEigenenMandantDialog.caption",
        dialogText: "loescheEigenenMandantDialog.dialogText",
        dialogWarning: "loescheEigenenMandantDialog.dialogWarning",
        kennung: "loescheEigenenMandantDialog.kennung",
        loeschen: "loescheEigenenMandantDialog.loeschen",
        abbrechen: "loescheEigenenMandantDialog.abbrechen",
        bezeichnung: "loescheEigenenMandantDialog.bezeichnung",
        mandantGeloescht: "loescheEigenenMandantDialog.mandantGeloescht",
    },
    bestaetigeEMailDialog: {
        bestaetige: "bestaetigeEMailDialog.bestaetige",
        dialogTitle: "bestaetigeEMailDialog.dialogTitle",
        dialogText: "bestaetigeEMailDialog.dialogText",
        zumLogin: "bestaetigeEMailDialog.zumLogin",
        abgelaufenTitle: "bestaetigeEMailDialog.abgelaufenTitle",
        abgelaufen: "bestaetigeEMailDialog.abgelaufen",
    },
    kontoMandantStatus: {
        aktiv: "kontoMandantStatus.aktiv",
        besitzer: "kontoMandantStatus.besitzer",
        eingeladen: "kontoMandantStatus.eingeladen"
    },
    teamsKontenView: {
        microsoftTeamsKonten: "teamsKontenView.microsoftTeamsKonten",
        microsoftTeamsKonto: "teamsKontenView.microsoftTeamsKonto",
        verknuepfen: "teamsKontenView.verknuepfen",
        loesen: "teamsKontenView.loesen",
        status: "teamsKontenView.status",
        aktiv: "teamsKontenView.aktiv",
    },
    teamsKontenBreadcrumb: {
        microsoftTeamsKonten: "teamsKontenBreadcrumb.microsoftTeamsKonten",
    },
    zoomNutzerView: {
        zoomNutzer: "zoomNutzerView.zoomNutzer",
        verknuepfen: "zoomNutzerView.verknuepfen",
        loesen: "zoomNutzerView.loesen",
        status: "zoomNutzerView.status",
        aktiv: "zoomNutzerView.aktiv",
        eingeschraenkt: "zoomNutzerView.eingeschraenkt",
    },
    zoomNutzerBreadcrumb: {
        zoomNutzer: "zoomNutzerBreadcrumb.zoomNutzer",
    },
    zoomAccountView: {
        zoomAccount: "zoomAccountView.zoomAccount",
        zoomNutzer: "zoomAccountView.zoomNutzer",
        aktiv: "zoomAccountView.aktiv",
        inaktiv: "zoomAccountView.inaktiv",
        status: "zoomAccountView.status",
        verknuepfen: "zoomAccountView.verknuepfen",
        verknuepfungloesen: "zoomAccountView.verknuepfungLoesen",
        alsHauptnutzerWaehlen: "zoomAccountView.alsHauptnutzerWaehlen",
        hauptnutzer: "zoomAccountView.hauptnutzer",
        dialogCaption: "zoomAccountView.dialogCaption",
        dialogText: "zoomAccountView.dialogText",
        trotzdemLoesen: "zoomAccountView.trotzdemLoesen",
        abbrechen: "zoomAccountView.abbrechen",
    },
    zoomAccountsBreadcrumb: {
        zoomAccounts: "zoomAccountsBreadcrumb.zoomAccounts",
    },
    zoomAccountsNavigationView: {
        zoomAccounts: "zoomAccountsNavigationView.zoomAccounts",
    },
    stripeKontoBreadcrumb: {
        stripeKonto: "stripeKontoBreadcrumb.stripeKonto",
    },
    stripeKontoView: {
        stripeKonto: "stripeKontoView.stripeKonto",
        verknuepfen: "stripeKontoView.verknuepfen",
        beiStripeBearbeiten: "stripeKontoView.beiStripeBearbeiten",
        verknuepfungLoesen: "stripeKontoView.verknuepfungLoesen",
        keinStripeKontoVerknuepft: "stripeKontoView.keinStripeKontoVerknuepft",
        zahlungsmethoden: "stripeKontoView.zahlungsmethoden",
    },
    stripeKontoVerknuepfenDialog: {
        dialogCaption: "stripeKontoVerknuepfenDialog.dialogCaption",
        dialogText: "stripeKontoVerknuepfenDialog.dialogText",
        verknuepfen: "stripeKontoVerknuepfenDialog.verknuepfen",
        abbrechen: "stripeKontoVerknuepfenDialog.abbrechen",
        vertragsadresseName1: "stripeKontoVerknuepfenDialog.vertragsadresseName1",
        vertragsadresseName2: "stripeKontoVerknuepfenDialog.vertragsadresseName2",
        vertragsadresseName3: "stripeKontoVerknuepfenDialog.vertragsadresseName3",
        vertragsadresseStrasse: "stripeKontoVerknuepfenDialog.vertragsadresseStrasse",
        vertragsadressePostleitzahl: "stripeKontoVerknuepfenDialog.vertragsadressePostleitzahl",
        vertragsadresseOrt: "stripeKontoVerknuepfenDialog.vertragsadresseOrt",
        vertragsadresseRegion: "stripeKontoVerknuepfenDialog.vertragsadresseRegion",
        vertragsadresseLand: "stripeKontoVerknuepfenDialog.vertragsadresseLand",
        vertragsadresseEMail: "stripeKontoVerknuepfenDialog.vertragsadresseEMail",
        vertragsadresseTelefon: "stripeKontoVerknuepfenDialog.vertragsadresseTelefon",
        vertragsadresseMobil: "stripeKontoVerknuepfenDialog.vertragsadresseMobil",
        vertragsadresseFax: "stripeKontoVerknuepfenDialog.vertragsadresseFax",
        vertragsadresseUmsatzsteuerIdNr: "stripeKontoVerknuepfenDialog.vertragsadresseUmsatzsteuerIdNr",
        vertragsadresseSteuernummer: "stripeKontoVerknuepfenDialog.vertragsadresseSteuernummer",
        rechnungsadresse: "stripeKontoVerknuepfenDialog.rechnungsadresse",
        rechnungsadresseName1: "stripeKontoVerknuepfenDialog.rechnungsadresseName1",
        rechnungsadresseName2: "stripeKontoVerknuepfenDialog.rechnungsadresseName2",
        rechnungsadresseName3: "stripeKontoVerknuepfenDialog.rechnungsadresseName3",
        rechnungsadresseStrasse: "stripeKontoVerknuepfenDialog.rechnungsadresseStrasse",
        rechnungsadressePostleitzahl: "stripeKontoVerknuepfenDialog.rechnungsadressePostleitzahl",
        rechnungsadresseOrt: "stripeKontoVerknuepfenDialog.rechnungsadresseOrt",
        rechnungsadresseRegion: "stripeKontoVerknuepfenDialog.rechnungsadresseRegion",
        rechnungsadresseLand: "stripeKontoVerknuepfenDialog.rechnungsadresseLand",
        rechnungsadresseEMail: "stripeKontoVerknuepfenDialog.rechnungsadresseEMail",
        rechnungsadresseTelefon: "stripeKontoVerknuepfenDialog.rechnungsadresseTelefon",
        rechnungsadresseMobil: "stripeKontoVerknuepfenDialog.rechnungsadresseMobil",
        rechnungsadresseFax: "stripeKontoVerknuepfenDialog.rechnungsadresseFax",
        rechnungsadresseUmsatzsteuerIdNr: "stripeKontoVerknuepfenDialog.rechnungsadresseUmsatzsteuerIdNr",
        rechnungsadresseSteuernummer: "stripeKontoVerknuepfenDialog.rechnungsadresseSteuernummer",
    },
    stripeKontoVerknuepfungLoesenDialog: {
        dialogCaption: "stripeKontoVerknuepfungLoesenDialog.dialogCaption",
        dialogText: "stripeKontoVerknuepfungLoesenDialog.dialogText",
        verknuepfungLoesen: "stripeKontoVerknuepfungLoesenDialog.verknuepfungLoesen",
        abbrechen: "stripeKontoVerknuepfungLoesenDialog.abbrechen",
    },
    stripekontostatusstatus: {
        aktiv: "stripekontostatusstatus.aktiv",
        angabenErforderlich: "stripekontostatusstatus.angabenErforderlich",
        auszahlungenDeaktiviert: "stripekontostatusstatus.auszahlungenDeaktiviert",
        eingeschraenkt: "stripekontostatusstatus.eingeschraenkt",
        gebuehrenDeaktiviert: "stripekontostatusstatus.gebuehrenDeaktiviert",
    },
    loescheTeamsKontenDialog: {
        caption: "loescheTeamsKontenDialog.caption",
        text: "loescheTeamsKontenDialog.text",
        coffeeMugText: "loescheTeamsKontenDialog.coffeeMugText",
    },
    loescheZoomNutzerDialog: {
        caption: "loescheZoomKontenDialog.caption",
        text: "loescheZoomKontenDialog.text",
        coffeeMugText: "loescheZoomKontenDialog.coffeeMugText",
    },
    finanzeinstellungenView: {
        details: "finanzeinstellungenView.details",
        finanzeinstellungen: "finanzeinstellungenView.finanzeinstellungen",
    },
    zahlungsmethodenTyp: {
        karte: "zahlungsmethodenTyp.karte",
        sepa: "zahlungsmethodenTyp.sepa",
    },
    zahlungsmethodenstatus: {
        zahldatenAusstehend: "zahlungsmethodenstatus.zahldatenAusstehend",
        bestaetigungAusstehend: "zahlungsmethodenstatus.bestaetigungAusstehend",
        aktionAusstehend: "zahlungsmethodenstatus.aktionAusstehend",
        verarbeitung: "zahlungsmethodenstatus.verarbeitung",
        storniert: "zahlungsmethodenstatus.storniert",
        erfolgreichEingerichtet: "zahlungsmethodenstatus.erfolgreichEingerichtet",
    },
    marke: {
        unbekannt: "marke.unbekannt",
        americanExpress: "marke.americanExpress",
        dinersClub: "marke.dinersClub",
        discover: "marke.discover",
        jcb: "marke.jcb",
        mastercard: "marke.mastercard",
        unionpay: "marke.unionpay",
        visa: "marke.visa",
    },
    zahlungsmethodeAendernDialog: {
        dialogTitle: "zahlungsmethodeAendernDialog.dialogTitle",
        dialogText: "zahlungsmethodeAendernDialog.dialogText",
        speichern: "zahlungsmethodeAendernDialog.speichern",
        abbrechen: "zahlungsmethodeAendernDialog.abbrechen",
        ichAkzeptiereDen: "zahlungsmethodeAendernDialog.ichAkzeptiereDen",
    },
    useZahlungsmethodeAendern: {
        fehlerInitialisierung: "useZahlungsmethodeAendern.fehlerInitialisierung",
        fehlerZahlungsmethodeAnlegen: "useZahlungsmethodeAendern.fehlerZahlungsmethodeAnlegen",
        fehlerZahlungsdienstleister: "useZahlungsmethodeAendern.fehlerZahlungsdienstleister",
    },
    belegstatus: {
        annulliert: "belegstatus.annulliert",
        bezahlt: "belegstatus.bezahlt",
        entwurf: "belegstatus.entwurf",
        uneinbringlich: "belegstatus.uneinbringlich",
        offen: "belegstatus.offen"
    },
    belegart: {
        rechnung: "belegart.rechnung",
        gutschrift: "belegart.gutschrift"
    },
    mandantBelegeBreadcrumb: {
        belege: "mandantBelegeBreadcrumb.belege",
    },
    mandantBelegeView: {
        datum: "mandantBelegeView.datum",
        art: "mandantBelegeView.art",
        betrag: "mandantBelegeView.betrag",
        status: "mandantBelegeView.status",
        download: "mandantBelegeView.download",
        beleg: "mandantBelegeView.beleg",
        belege: "mandantBelegeView.belege",
    },
    mandantBelegProvisionenView: {
        beleg: "mandantBelegProvisionenView.beleg",
        provisionsbetrag: "mandantBelegProvisionenView.provisionsbetrag",
        provisionssatz: "mandantBelegProvisionenView.provisionssatz",
        teilnahmen: "mandantBelegProvisionenView.teilnahmen",
        geloescht: "mandantBelegProvisionenView.geloescht",
        exportieren: "mandantBelegProvisionenView.exportieren"
    },
    firmendatenFehlenDialog: {
        dialogCaption: "firmendatenFehlenDialog.dialogCaption",
        dialogText: "firmendatenFehlenDialog.dialogText",
        zuDenFirmendaten: "firmendatenFehlenDialog.zuDenFirmendaten",
        abbrechen: "firmendatenFehlenDialog.abbrechen"
    },
    paypalKontoView: {
        verknuepfen: "paypalKontoView.verknuepfen",
        verknuepfungLoesen: "paypalKontoView.verknuepfungLoesen",
        paypalKonto: "paypalKontoView.paypalKonto",
        keinKontoVerknuepft: "paypalKontoView.keinKontoVerknuepft",
        aktiv: "paypalKontoView.aktiv",
        eMailNichtBestaetigt: "paypalKontoView.eMailNichtBestaetigt",
        berechtigungenFehlen: "paypalKontoView.berechtigungenFehlen",
        informationenFehlen: "paypalKontoView.informationenFehlen",
        payPalLoginFehlt: "paypalKontoView.payPalLoginFehlt",
        beiPayPalBearbeiten: "paypalKontoView.beiPayPalBearbeiten"
    },
    payPalKontoVerknuepfungLoeschenDialog: {
        dialogCaption: "payPalKontoVerknuepfungLoeschenDialog.dialogCaption",
        dialogText: "payPalKontoVerknuepfungLoeschenDialog.dialogText",
        verknuepfungLoesen: "payPalKontoVerknuepfungLoeschenDialog.verknuepfungLoesen",
        abbrechen: "payPalKontoVerknuepfungLoeschenDialog.abbrechen",
    },
    payPalKontoBreadcrumb: {
        payPalKonto: "payPalKontoBreadcrumb.payPalKonto",
    },
    supportMandantProvisionsdatenView: {
        speichern: "supportMandantProvisionsdatenView.speichern",
        zahlungsmethodeHinterlegenBis: "supportMandantProvisionsdatenView.zahlungsmethodeHinterlegenBis",
        keineProvisionBisDatum: "supportMandantProvisionsdatenView.keineProvisionBisDatum",
        provisionssatz: "supportMandantProvisionsdatenView.provisionssatz",
        provisionMindestbetrag: "supportMandantProvisionsdatenView.provisionMindestbetrag",
        kundenkontoAutomatischBelasten: "supportMandantProvisionsdatenView.kundenkontoAutomatischBelasten",
        zahlungsmethode: "supportMandantProvisionsdatenView.zahlungsmethode",
        provision: "supportMandantProvisionsdatenView.provision",
        staffelProvision: "supportMandantProvisionsdatenView.staffelProvision",
        hatStaffelProvision: "supportMandantProvisionsdatenView.hatStaffelProvision",
        schrittprovision: "supportMandantProvisionsdatenView.schrittprovision",
        schrittbetrag: "supportMandantProvisionsdatenView.schrittbetrag",
        staffelProvisionMindestbetrag: "supportMandantProvisionsdatenView.staffelProvisionMindestbetrag",
        fixeGrundprovision: "supportMandantProvisionsdatenView.fixeGrundprovision",
        staffelProvisionTooltip: "supportMandantProvisionsdatenView.staffelProvisionTooltip",
        staffelProvisionIstBrutto: "supportMandantProvisionsdatenView.staffelProvisionIstBrutto",
        maximaleGesamtprovision: "supportMandantProvisionsdatenView.maximaleGesamtprovision",
        minimaleGesamtprovision: "supportMandantProvisionsdatenView.minimaleGesamtprovision",
        maximalerAbrechnungsbetragProMonat: "supportMandantProvisionsdatenView.maximalerAbrechnungsbetragProMonat",
        abrechnungAb: "supportMandantProvisionsdatenView.abrechnungAb"
    },
    waehleVerknuepfenVarianteDialog: {
        titel: "waehleVerknuepfenVarianteDialog.titel",
        text: "waehleVerknuepfenVarianteDialog.text",
        neu: "waehleVerknuepfenVarianteDialog.neu",
        geloest: "waehleVerknuepfenVarianteDialog.geloest",
        abbrechen: "waehleVerknuepfenVarianteDialog.abbrechen",
        ausfuehren: "waehleVerknuepfenVarianteDialog.ausfuehren",
    },
    mandantBelegView: {
        details: "mandantBelegView.details",
        provisionen: "mandantBelegView.provisionen",
        beleg: "mandantBelegView.beleg",
    },
    mandantBelegDetailsView: {
        herunterladen: "mandantBelegDetailsView.herunterladen",
        details: "mandantBelegDetailsView.details",
        nummer: "mandantBelegDetailsView.nummer",
        datum: "mandantBelegDetailsView.datum",
        preis: "mandantBelegDetailsView.preis",
        status: "mandantBelegDetailsView.status",
    },
    mandantBelegeNavigationView: {
        belege: "mandantBelegeNavigationView.belege",
    },
    mandantBelegProvisionenBreadcrumb: {
        provisionen: "mandantBelegProvisionenBreadcrumb.provisionen",
    },
    aendereEigeneBasisUrlDialog: {
        dialogCaption: "aendereEigeneBasisUrlDialog.dialogCaption",
        dialogContentText: "aendereEigeneBasisUrlDialog.dialogContentText",
        url: "aendereEigeneBasisUrlDialog.url",
        speichern: "aendereEigeneBasisUrlDialog.speichern",
        abbrechen: "aendereEigeneBasisUrlDialog.abbrechen",
    },
    erstelleProvisionenCsvExportDialog: {
        dialogTitle: "erstelleProvisionenCsvExportDialog.dialogTitle",
    },
    auftragverarbeitungsvertragDownloadLink: {
        vertragZurAuftragsverarbeitung: "auftragverarbeitungsvertragDownloadLink.vertragZurAuftragsverarbeitung",
        vertragWirdHeruntergeladen: "auftragverarbeitungsvertragDownloadLink.vertragWirdHeruntergeladen",
    },
    vertragZurNutzungDerSaaSLoesungDownloadLink: {
        vertragZurNutzungDerSaaSLoesung: "vertragZurNutzungDerSaaSLoesungDownloadLink.vertragZurNutzungDerSaaSLoesung",
        vertragWirdHeruntergeladen: "vertragZurNutzungDerSaaSLoesungDownloadLink.vertragWirdHeruntergeladen",
    },
    loescheKontoMandantZuEigenemMandantDialog: {
        loeschen: "loescheKontoMandantZuEigenemMandantDialog.loeschen",
        abbrechen: "loescheKontoMandantZuEigenemMandantDialog.abbrechen",
        title: "loescheKontoMandantZuEigenemMandantDialog.title",
        text: "loescheKontoMandantZuEigenemMandantDialog.text",
        bestaetigung_1: "loescheKontoMandantZuEigenemMandantDialog.bestaetigung_1",
        bestaetigung_2: "loescheKontoMandantZuEigenemMandantDialog.bestaetigung_2",
        bestaetigung: "loescheKontoMandantZuEigenemMandantDialog.bestaetigung"
    },
    supportMandantDatenschutzeinstellungenView: {
        speichern: "supportMandantDatenschutzeinstellungenView.speichern",
        katholischerKirchlicherDatenschutz: "supportMandantDatenschutzeinstellungenView.katholischerKirchlicherDatenschutz",
    },
    supportMandantDatenschutzeinstellungenBreadcrumb: {
        datenschutzeinstellungen: "supportMandantDatenschutzeinstellungenBreadcrumb.datenschutzeinstellungen"
    },
    verbesserungsvorschlaegeView: {
        title: "verbesserungsvorschlaegeView.title",
    },
    verbesserungsvorschlaegeBreadcrumb: {
        caption: "verbesserungsvorschlaegeBreadcrumb.caption",
    },
    roadmapView: {
        title: "roadmapView.title",
    },
    roadmapBreadcrumb: {
        caption: "roadmapBreadcrumb.caption",
    },
    abrechnungAb: {
        [AbrechnungAb.RECHNUNGSERSTELLUNG]: "abrechnungAb.RECHNUNGSERSTELLUNG",
        [AbrechnungAb.RECHNUNGSFREIGABE]: "abrechnungAb.RECHNUNSGFREIGABE"
    },
};

export const kontoMandantStatusTranslationKeysMap = {
    [KontoMandantStatusSammlung.aktiv]: translationKeys.kontoMandantStatus.aktiv,
    [KontoMandantStatusSammlung.besitzer]: translationKeys.kontoMandantStatus.besitzer,
    [KontoMandantStatusSammlung.eingeladen]: translationKeys.kontoMandantStatus.eingeladen,
};

export const stripekontostatusstatusTranslationKeysMap = {
    [KontostatusSammlung.aktiv]: translationKeys.stripekontostatusstatus.aktiv,
    [KontostatusSammlung.angabenErforderlich]: translationKeys.stripekontostatusstatus.angabenErforderlich,
    [KontostatusSammlung.auszahlungenDeaktiviert]: translationKeys.stripekontostatusstatus.auszahlungenDeaktiviert,
    [KontostatusSammlung.eingeschraenkt]: translationKeys.stripekontostatusstatus.eingeschraenkt,
    [KontostatusSammlung.gebuehrenDeaktiviert]: translationKeys.stripekontostatusstatus.gebuehrenDeaktiviert,
};

export const belegstatusTranslationKeysMap = {
    [BelegstatusWerte.annulliert]: translationKeys.belegstatus.annulliert,
    [BelegstatusWerte.bezahlt]: translationKeys.belegstatus.bezahlt,
    [BelegstatusWerte.entwurf]: translationKeys.belegstatus.entwurf,
    [BelegstatusWerte.offen]: translationKeys.belegstatus.offen,
    [BelegstatusWerte.uneinbringlich]: translationKeys.belegstatus.uneinbringlich
}

export const belegartTranslationKeysMap = {
    [Belegarten.rechnung]: translationKeys.belegart.rechnung,
    [Belegarten.gutschrift]: translationKeys.belegart.gutschrift,
}

export const zahlungsmethodenstatusTranslationKeysMap = {
    [ZahlungsmethodenstatusSammlung.zahldatenAusstehend]: translationKeys.zahlungsmethodenstatus.zahldatenAusstehend,
    [ZahlungsmethodenstatusSammlung.bestaetigungAusstehend]: translationKeys.zahlungsmethodenstatus.bestaetigungAusstehend,
    [ZahlungsmethodenstatusSammlung.aktionAusstehend]: translationKeys.zahlungsmethodenstatus.aktionAusstehend,
    [ZahlungsmethodenstatusSammlung.verarbeitung]: translationKeys.zahlungsmethodenstatus.verarbeitung,
    [ZahlungsmethodenstatusSammlung.storniert]: translationKeys.zahlungsmethodenstatus.storniert,
    [ZahlungsmethodenstatusSammlung.erfolgreichEingerichtet]: translationKeys.zahlungsmethodenstatus.erfolgreichEingerichtet,
};

export const zahlungsmethodenTypTranslationKeysMap = {
    [ZahlungsmethodentypSammlung.sepa]: translationKeys.zahlungsmethodenTyp.sepa,
    [ZahlungsmethodentypSammlung.karte]: translationKeys.zahlungsmethodenTyp.karte,
};

export const markeTranslationKeysMap = {
    [MarkeSammlung.unbekannt]: translationKeys.marke.unbekannt,
    [MarkeSammlung.americanExpress]: translationKeys.marke.americanExpress,
    [MarkeSammlung.dinersClub]: translationKeys.marke.dinersClub,
    [MarkeSammlung.discover]: translationKeys.marke.discover,
    [MarkeSammlung.jcb]: translationKeys.marke.jcb,
    [MarkeSammlung.mastercard]: translationKeys.marke.mastercard,
    [MarkeSammlung.unionpay]: translationKeys.marke.unionpay,
    [MarkeSammlung.visa]: translationKeys.marke.visa,
};